<template>
	<sky-charts
		:api-conf="apiConf"
		:before-render="beforeRender"
		ref="chart"
		:queryCondition="condition"
		:config="chartConfig"
		:table-style="{ name: 'mixture' }"
	>
	</sky-charts>
</template>

<script>
import apiConf from '@/backend/apiConfig/apiConfig';
import mixins from './ga_mixins';
import copyText from '@/components/tools/copy-text';
import weburlSelect from '@/components/website/weburlSelect.js';
export default {
	name: 'ga_site',
	// mixins: [mixins],
	props: {
		condition: {
			required: false,
		},
	},
	data() {
		return {
			apiConf: null,
			chartConfig: {
				name: '网站分析',
				type: 'data-list',
				tableStyle: {
					name: 'webclient',
				},
				columns: [],
				// showSummary: true,
				// getSummaries: (param) => {
				//     return ['总计', this.data.visitorCount, this.data.pvCount, this.data.bounceRate, this.data.pageDuration]
				// }
			},
			data: {},
		};
	},
	watch: {
		condition: {
			handler(val) {
				this.apiConf = {
					api: apiConf.website['get' + weburlSelect(val.status) + 'SiteReport'],
					config: {
						timeout: 60000,
					},
				};
				let status = val.status === 1 ? 'true' : val.status === 2 ? 'false' : '';
				this.setcolumns(status);
			},
		},
		immediate: true,
		deep: true,
	},
	methods: {
		beforeRender(obj) {
			this.data = obj;
			return obj.visitToppageDetailList;
		},
		setcolumns(status) {
			this.chartConfig.columns = [
				{
					label: '网页',
					bind: 'completeUrl',
					type: 'custom',
					componentName: copyText,
					bindCopy: 'completeUrl',
					clickFn(row) {
						window.open(row.completeUrl);
					},
					minWidth: 350,
				},
				{
					labelFn: () => {
						return `${status ? '用户数' : '访客数'}(${this.data.visitorCount})`;
					},
					bind: 'visitorCount',
					align: 'center',
					sort: 'visitorCount',
					options: [
						{
							label: '由低到高',
							value: 'asc',
						},
						{
							label: '由高到低',
							value: 'desc',
						},
					],
				},
				{
					labelFn: () => {
						return `用户占比`;
					},
					type: 'percentage',
					bind: 'visitorRatio',
					align: 'center',
					dataStyle(val) {
						return val + '%';
					},
				},
				{
					labelFn: () => {
						return `浏览量(${this.data.pvCount})`;
					},
					bind: 'pvCount',
					align: 'center',
					sort: 'pvCount',
					options: [
						{
							label: '由低到高',
							value: 'asc',
						},
						{
							label: '由高到低',
							value: 'desc',
						},
					],
				},
				{
					labelFn: () => {
						return `浏览量占比`;
					},
					type: 'percentage',
					bind: 'pvRatio',
					align: 'center',
					dataStyle(val) {
						return val + '%';
					},
				},
				{
					labelFn: () => {
						return '跳出率';
						// return `跳出率(${this.data.exitRatio}%)`;
					},
					label: '跳出率',
					type: 'percentage',
					bind: 'exitRatio',
					align: 'center',
					dataStyle(val) {
						return val + '%';
					},
					sort: 'exitRatio',
					options: [
						{
							label: '由低到高',
							value: 'asc',
						},
						{
							label: '由高到低',
							value: 'desc',
						},
					],
				},
				{
					width: 160,
					labelFn: () => {
						return '平均停留时间';
						// return `平均停留时间(${this.data.avgVisitTimeStr})`;
					},
					label: '平均停留时间',
					bind: 'avgVisitTimeStr',
					align: 'center',
					sort: 'avgVisitTimeStr',
					options: [
						{
							label: '由低到高',
							value: 'asc',
						},
						{
							label: '由高到低',
							value: 'desc',
						},
					],
				},
			];
		},
	},
};
</script>

<style scoped></style>
